<div class="kt-form w-webkit-fill-available" *ngIf="dropdown.locales.length > 0">
  <div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">

    <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="form-group row mb-3 align-items-center">
          <div class="col-md-1 kt-form__label col-form-label">
            <label class="mb-0">JS Plugins:</label>
          </div>
          <div class="col-md-11 d-flex align-items-center plugin-tab-wrapper">
            <ng-container *ngIf="visiblePluginTypes && visiblePluginTypes.length > 0; else noTabPermission">
              <button
                *ngFor="let plugin of visiblePluginTypes"
                type="button"
                class="btn btn-sm plugin-tab-button mr-2"
                [ngClass]="{'active-plugin-tab': activeType === plugin.id}"
                (click)="onTypeChanged(plugin.id)">
                {{ plugin.name }}
              </button>
            </ng-container>
            <ng-template #noTabPermission>
              <span class="text-muted">You do not have permission to view any of these tabs.</span>
            </ng-template>
            <ng-template #fallbackPluginButtons>
              <button type="button" class="btn btn-sm plugin-tab-button mr-2" [ngClass]="{'active-plugin-tab': activeType === 1}" (click)="onTypeChanged(1)">Live Chat</button>
              <button type="button" class="btn btn-sm plugin-tab-button" [ngClass]="{'active-plugin-tab': activeType === 2}" (click)="onTypeChanged(2)">Mini Game</button>
            </ng-template>
          </div>
        </div>
        <form [formGroup]="form">
          <div class="row align-items-center">
            <div class="col-xl-12 order-2 order-xl-1">
              <div class="row mb-3">
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>{{ 'Status' }}:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select formControlName="status" class="form-control">
                    <option value="all"> {{'All' }} </option>
                    <option [value]="i" *ngFor="let value of dropdown.statuses; let i = index">
                      {{ value }}
                    </option>
                  </select>
                </div>
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>{{ 'Locale' }}:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select formControlName="settings_locale_id" class="form-control">
                    <option value="all"> {{'All' }} </option>
                    <option [value]="value.id" *ngFor="let value of dropdown.locales">
                      {{ value.code }}
                    </option>
                  </select>
                </div>
                <div class="col-md-1 kt-form__label col-form-label">
                  <label>{{ 'Provider'}}:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                  <select *ngIf="activeType === 1" formControlName="live_chat_platform_id" class="form-control">
                    <option value="all">{{ 'All' }}</option>
                    <ng-container *ngFor="let value of dropdown.platform | async">
                      <option [value]="value.id">{{ value.name }}</option>
                    </ng-container>
                  </select>
                  <select *ngIf="activeType === 2" formControlName="mini_game_platform_id" class="form-control">
                    <option value="all">{{ 'All' }}</option>
                    <ng-container *ngFor="let value of miniGamePlatform">
                      <option [value]="value.id">{{ value.name }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="kt-section col-12 row d-flex justify-content-between mb-0 mt-1">
          <div class="dropdown dropdown-inline w-100 d-flex align-items-center justify-content-between">
            <div>
              <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading"
                (search)="onSubmitClick()"></kt-search-button>
              <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading"
                (clear)="onSubmitClick(true)"></kt-clear-button>
            </div>
            <div>
              <button *ngIf="canUpdateAIChatbotStatus" (click)="onOpenLivechatSettings()" class="btn btn-setting btn-icon-sm mr-2"><i class="fas fa-cog"></i>Livechat Settings</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body pt-12 pb-0">
          <div class="kt-section">
            <div class="kt-section__content">
              <div class="table-responsive">
                <table class="table table-bordered table-hover table-striped table-sortable">
                  <thead>
                    <tr>
                      <th width="5" class="sort-enabled pointer" (click)="onSortColumn('id')"
                        [ngClass]="sortingConfig.id" [class.sort-selected]="sortingSelection.sort_by === 'id'">{{ 'Id' |
                        uppercase }}</th>
                      <th width="5" class="pr-0">{{ 'Locale' | uppercase }}
                      </th>
                      <th width="5" class="pl-1 pr-5">
                        <div class="dropdown selected-category-container ml-1" *ngIf="displayLocale != null">
                          <button class="dropdown-toggle d-flex justify-content-center dropdown-box" type="button"
                            data-toggle="dropdown" style="margin: 0 auto">
                            <p class="mr-1">{{ displayLocale['code'] | uppercase }} </p>
                            <i class="fa fa-sort-down"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-box-open">
                            <li *ngFor="let value of dropdown.locales" class="selected-category-container2 ml-0"
                              (click)="changeLocale(value)">
                              {{ value.code | uppercase }}
                            </li>
                          </ul>
                        </div>
                      </th>
                      <th>{{ 'Provider' | uppercase }}</th>
                      <th width="500">{{ 'Script' | uppercase }}</th>
                      <th *ngIf="activeType === 1">{{ 'Chat Page' | uppercase }}</th>
                      <th>{{ 'Status' | uppercase }}</th>
                      <th class="text-center pr-13">{{ 'Actions' | uppercase}}</th>
                    </tr>
                    <tr *ngIf="canCreateScript && (!mode || mode != 'create')">
                      <th colspan="100%" class="pr-0 pl-0">
                        <div class="content-container text-center" (click)="expandRowCreate('create')">
                          <span><i class="fas fa-plus mr-2"></i>Create New Content</span>
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="mode == 'create'">
                      <th colspan="100%" class="pr-0 pl-0">
                        <ng-container *ngIf="!mode else contents"></ng-container>
                      </th>
                    </tr>
                  </thead>
                  <tbody *ngIf="(liveChat$ | async) as rows">
                    <ng-container *ngFor="let row of rows">
                      <tr>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''">{{
                          row.id }}</td>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''"
                          colspan="2" width="1" class="pr-5">
                          <div style="width: 100px;">
                            {{ row.locale_list }}
                          </div>
                        </td>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''">{{ activeType === 1 ? row.live_chat_platform_name : (row.mini_game_platform_name || row.live_chat_platform_name) }}</td>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''"
                          class="script-content">{{ displayLocaleContent(row, 'script') }}</td>
                        <td *ngIf="activeType === 1" class="script-content" [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''">{{
                          displayLocaleContent(row, 'chat_page') }}</td>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''">
                          <label class="switch">
                            <input [disabled]="!canEditScript && !canUpdateScriptStatus" type="checkbox" id="togBtn" [id]="row.id" [checked]="row.status === 1 ? true : false"
                              (change)="onChangeStatus($event, row)">
                            <div class="slider round">
                              <span class="on">ON</span>
                              <span class="off">OFF</span>
                            </div>
                          </label>
                        </td>
                        <td [style]="mode == 'edit' && liveChat.id == row.id ? 'border-bottom: 0 !important;' : ''"
                          class="text-center actions-column">
                          <button *ngIf="canViewScriptDetails" matTooltip="{{ 'View' }}" class="btn btn-elevate btn-sm btn-icon btn-icon-sm"
                            (click)="expandRowEdit('edit', row)"><i class="fas fa-cog"></i></button>
                        </td>
                      </tr>
                      <tr *ngIf="mode == 'edit' && liveChat.id == row.id">
                        <td colspan="100%" class="pr-0 pl-0 pt-0 pb-0" style="border-bottom: 0 !important;">
                          <ng-container *ngIf="!mode else contents"></ng-container>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                  <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength"
                    class="text-gray-600 fw-bold table-handler"></tbody>
                </table>
              </div>
              <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize" [directionLinks]="true"
                  [boundaryLinks]="true" [rotate]="true" [collectionSize]="pagination.total"
                  (pageChange)="onViewPageBy(page)">
                </ngb-pagination>
                <div class="kt-pagination__toolbar">
                  <select (change)="onPerPage($event)" [(ngModel)]="pageSize"
                    class="form-control kt-font-brand page-size">
                    <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                  </select>
                  <span class="pagination__desc">
                    Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #contents>
  <form [formGroup]="formContent">
    <div class="create-content-container" *ngIf="dropdown.locales.length > 0">
      <div class="row col-12 p-0 m-0">
        <div class="col-12 mb-2" *ngIf="mode == 'create'">
          <span class="header">{{ activeType === 1 ? 'Create New Live Chat' : 'Create New Mini Game' }}</span>
        </div>
        <div class="form-group col-3 mb-3">
          <label>{{ 'Provider' }}: <span class="text-danger">*</span></label>
          <select *ngIf="activeType === 1" formControlName="live_chat_platform_id" class="form-control">
            <option value="null" disabled hidden>{{ 'Please Select' | translate }}</option>
            <option *ngFor="let value of dropdown.platform | async; let i = index;" [value]="value.id">
              {{ value.name }}
            </option>
          </select>
          <select *ngIf="activeType === 2" formControlName="mini_game_platform_id" class="form-control">
            <option value="null" disabled hidden>{{ 'Please Select' | translate }}</option>
            <option *ngFor="let value of miniGamePlatform; let i = index;" [value]="value.id">
              {{ value.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-3 mb-3" *ngIf="activeType === 1">
          <label class="control-label"> Member Groups <span class="text-danger">*</span></label>
          <div class="pl-0">
              <kt-dropdown-wo-lazyload
              [form]="formContent"
              [dropdownList]="memberGroupDropdownList"
              [selectedItems]="memberGroupSelectedItems"
              [selectionAttributes]="'id'"
              [formName]="'member_group'"
              [dropdownSettings]="memberGroupDropdownSettings"
              ></kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="form-group col-3 mb-3" *ngIf="mode == 'create'">
          <label>{{ 'Status' }}: <span class="text-danger">*</span></label>
          <select formControlName="status" class="form-control">
            <option [value]="i" *ngFor="let value of dropdown.statuses; let i = index">
              {{ value }}
            </option>
          </select>
        </div>
      </div>
      <hr>
      <mat-tab-group animationDuration="0ms" class="form-group mb-0 mat-tab-header-pagination-controls-enabled"
        formGroupName="locales" [selectedIndex]="localeIndex()" (selectedIndexChange)="activeFormLocale = dropdown.locales[$event]">
        <ng-container *ngIf="dropdown.locales.length > 0">
          <mat-tab *ngFor="let value of dropdown.locales; let i = index" [formGroupName]="value.id">
            <ng-template mat-tab-label>
              <span class="mat-tab">
                {{ value.code }}
                <div *ngIf="checkContent(value)" class="icon" (click)="clearContent(value)">
                  <i class="fas fa-times"></i>
                </div>
              </span>
            </ng-template>
            <div class="row col-12 p-0 m-0 mb-3">
              <div class="form-group col-12 mb-0 p-0">
                <label>{{ 'Script' }}: <span class="text-danger">*</span></label>
                <textarea rows="10" formControlName="script" class="form-control"
                  (keyup)="onChangeValidate($event, value.id, 'script')"></textarea>
              </div>
            </div>
            <div class="row col-12 p-0 m-0 mb-3" *ngIf="activeType === 2">
              <div class="form-group col-3 mb-3 pl-0 pr-4">
                <label>{{ 'Image' }}:</label>
                <label class="btn btn-default btn-sm btn-upload upload-icon" *ngIf="!formContent.get('locales').get('' + value.id).get('image_path').value && !isImageUploading">
                  <img src="assets/img/upload-icon.png">
                  <span>{{ 'Upload' }}</span>
                  <input class="form-control" type="file" hidden accept="image/*" (change)="onUploadFile($event)">
                </label>
                <div class="spinner-wrapper" *ngIf="isImageUploading">
                  <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                </div>
                <div *ngIf="formContent.get('locales').get('' + value.id).get('image_path').value && !isImageUploading" class="mt-2">
                  <div class="image-upload">
                    <div class="image-wrapper">
                      <img class="fas fa-trash position-absolute m-2 trash-icon" src="assets/img/trash-icon.png" (click)="onRemoveFile()">
                      <img class="img-fluid preview-image" alt="Mini Game Image" [src]="formContent.get('locales').get('' + value.id).get('image_path').value" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12 p-0 m-0 mt-2" *ngIf="activeType === 1">
              <div class="form-group col-12 mb-0 p-0">
                <label>{{ 'Chat Page' }}: <span class="text-danger">*</span></label>
                <input type="text" formControlName="chat_page" class="form-control"
                  (keyup)="onChangeValidate($event, value.id, 'chat_page')">
              </div>
            </div>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
      <div class="modal-footer">
        <table class="info mr-3" *ngIf="mode == 'edit'">
          <tr>
            <td class="header-hint">
              Updated by: {{ liveChat.updated_by ? liveChat.updated_by + '&nbsp;' : 'System&nbsp;' }}
            </td>
            <td class="header-hint">
              <span placement="bottom" [ngbTooltip]="updatedDateTime" container="body" class="tooltip-class">{{ liveChat.updated_at | timezoneDate:'YYYY-MM-DD HH:mm' }}</span>
              <ng-template #updatedDateTime>
                {{ liveChat.updated_at | timezoneDate:'YYYY-MM-DD HH:mm:ss' }}
              </ng-template>
            </td>
          </tr>
          <tr>
            <td class="header-hint">
              Created by: {{ liveChat.created_by ? liveChat.created_by + '&nbsp;' : 'System&nbsp;' }}
            </td>
            <td class="header-hint">
              <span placement="bottom" [ngbTooltip]="createdDateTime" container="body" class="tooltip-class">{{ liveChat.created_at | timezoneDate:'YYYY-MM-DD HH:mm' }}</span>
              <ng-template #createdDateTime>
                {{ liveChat.created_at | timezoneDate:'YYYY-MM-DD HH:mm:ss' }}
              </ng-template>
            </td>
          </tr>
        </table>
        <button type="button" class="btn btn-danger m-0 mr-2"
          (click)="mode == 'create' ? expandRowCreate('', true) : expandRowEdit('', null, true)">{{ 'Cancel' }}</button>
        <button *ngIf="(mode == 'create' && canCreateScript) || (mode == 'edit' && canEditScript)" type="button" class="btn btn-success m-0" [disabled]="isEmptyContent || !formContent.valid"
          (click)="onSave()">{{ mode != null && mode == 'create' ? 'Create' : 'Update' }}</button>
      </div>
    </div>
  </form>
</ng-template>

<kt-swal-alert [message]="messages$ | async" (confirmed)="reload()"></kt-swal-alert>
